module.exports = __webpack_public_path__ + "static/media/call.038ab63f.wav";